import axios from 'axios';

export function getActivesAnnonceursFields() {
  return axios.get(process.env.REACT_APP_ACTIVESANNONCEURSFIELDS_API_URL);
}

export default { getActivesAnnonceursFields };
